__turbopack_context__.v({
  "load5": "LoadingComponent-module-scss-module__F5ODtq__load5",
  "loader": "LoadingComponent-module-scss-module__F5ODtq__loader",
});
